module.exports = __webpack_public_path__ + "static/media/galeryCeilings2.d7d90f78.jpg";